import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { customerServiceGetStartedEntryPoint } from '@jira/spa-apps__customer-service-get-started/src/customerServiceGetStartedEntryPoint.entrypoint.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { csmGetStartedRoute } from '@jira/router-routes__servicedesk-customer-service-get-started-routes/src/csmGetStartedRoute.tsx';
import { GettingStartedPageSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/GettingStartedPageSkeleton.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceGetStartedPageEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main: customerServiceGetStartedEntryPoint,
		leftSidebar: {
			sidebar: csmAppSidebarEntryPoint,
			isProjectsExpanded: true,
		},
	});

export const csmGetStartedRouteEntry: Route = createEntry(csmGetStartedRoute, () => ({
	group: 'customer-service',
	layout: serviceProjectLayout,
	perfMetricKey: 'customer-service-get-started-page-load',
	skeleton: GettingStartedPageSkeleton,

	navigation: {
		sidebarId: SidebarIdCsmApp,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		staticProjectSidebarNavigationResource,
		servicedeskIssueTypesResource,
	],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? customerServiceGetStartedPageEntryPoint
			: notFoundPageEntrypoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
